import { render, staticRenderFns } from "./TreatmentPlanChartReview.vue?vue&type=template&id=0a204c8c&"
import script from "./TreatmentPlanChartReview.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports